import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "40",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "none",
  "fill-rule": "evenodd"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M21.63 11.815c0 5.42-4.394 9.815-9.815 9.815C6.395 21.63 2 17.236 2 11.815 2 6.395 6.394 2 11.815 2c5.42 0 9.815 4.394 9.815 9.815",
    stroke: "#FFF",
    "stroke-width": "3",
    fill: "#EFB025"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.053 11.815a1.51 1.51 0 1 1-3.02 0 1.51 1.51 0 0 1 3.02 0M13.577 11.815a1.51 1.51 0 1 0 3.02 0 1.51 1.51 0 0 0-3.02 0M14.643 16.848H9.239c-.245 0-.444-.169-.444-.377 0-.209.199-.378.444-.378h5.404c.245 0 .444.17.444.378s-.199.377-.444.377",
    fill: "#000"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}